"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("components");
var SelectColumn = function (_a) {
    var row = _a.row, selected = _a.selected, toggleSelect = _a.toggleSelect;
    return (React.createElement("div", { className: "row__column narrow" },
        React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: selected.find(function (i) { return i === row.id; }) ? 'selected' : '', circle: true, onClick: function () { return toggleSelect(row.id); } })));
};
exports.default = SelectColumn;
